/**
 * Quantas receitas distintas a pessoa já abriu, neste aparelho.
 *
 * Existe por causa de uma nota ruim que o app fabricou sozinho:
 *
 *   "You are asking me to rate website you haven't let me see YET"
 *
 * O AvisoDesignNovo montava no App assim que `isAuthenticated` virava true —
 * ou seja, por cima da primeira tela, antes de a pessoa ter usado nada. O voto
 * que isso colhe é sobre o aviso, não sobre o app, e quem vota irritado vota
 * uma estrela.
 *
 * Conta receitas DISTINTAS, não aberturas: abrir a mesma três vezes é uma
 * pessoa perdida, não uma pessoa que conheceu o app. Guarda só os ids até o
 * limite, porque depois de passar do limite o número exato não decide mais
 * nada.
 *
 * Sem armazenamento — aba anônima, iOS com dados de site bloqueados — o
 * contador fica em zero e o aviso simplesmente não aparece. Perder uma
 * avaliação é mais barato que colher uma errada.
 */
const CHAVE = "receitas_abertas";
const LIMITE = 3;

/** Evento local para quem está montado reagir sem esperar troca de rota. */
export const EVENTO_RECEITA_ABERTA = "glucofy:receita-aberta";

function ler(): string[] {
  try {
    const cru = localStorage.getItem(CHAVE);
    const ids = cru ? JSON.parse(cru) : [];
    return Array.isArray(ids) ? ids.filter((i) => typeof i === "string") : [];
  } catch {
    return [];
  }
}

/** Quantas receitas distintas já foram abertas. */
export function receitasAbertas(): number {
  return ler().length;
}

/** Já abriu o bastante para valer a pena perguntar a opinião dela. */
export function jaUsouOApp(): boolean {
  return receitasAbertas() >= LIMITE;
}

/** Registra uma receita aberta. Repetir a mesma não conta de novo. */
export function registrarReceitaAberta(recipeId: string | null | undefined): void {
  if (!recipeId) return;
  const ids = ler();
  if (ids.includes(recipeId) || ids.length >= LIMITE) return;
  try {
    localStorage.setItem(CHAVE, JSON.stringify([...ids, recipeId]));
  } catch {
    return; // sem armazenamento: o contador fica parado, e tudo bem
  }
  window.dispatchEvent(new CustomEvent(EVENTO_RECEITA_ABERTA));
}
